// Monto en pesos → "1,000" / "262.50" (sin el signo $; cada vista lo antepone).
// Enteros sin decimales; con centavos, siempre dos decimales.
export function formatAmount(n) {
  const value = Number(n || 0);
  return value.toLocaleString('es-MX', {
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
